export const SOURCE_SYSTEM = {
  ADSERVER: 'ADSERVER',
  AUTOMATION: 'AUTOMATION',
  DV360: 'DV360',
};
